import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { OLD_MTG_IDs } from '../CardData/MTG-IDs';
import { testCardList } from '../CardData/tmp-card-list';
import { testGameData } from '../CardData/tmp-game-data';

const GameContext = createContext();

export const useGameContext = () => {
    return useContext(GameContext);
};

export const GameProvider = ({ children }) => {
    const [currentGame, setCurrentGame] = useState(false);
    const [isLoadingGameData, setIsLoadingGameData] = useState(false)
    const [gameData, setGameData] = useState(false)
    const [gameCards, setGameCards] = useState({})
    const hasBeenInitialized = useRef(false)
    const [readyToDisplay, setReadyToDisplay] = useState(false)
    const gamesStorageKey = "loaded_game_files"
    const [cardSize, setCardSize] = useState({ vh: 1 })

    useEffect(() => {
        if (!hasBeenInitialized.current) {
            hasBeenInitialized.current = true

            let loadedGamesJSON = localStorage.getItem(gamesStorageKey);

            if (loadedGamesJSON) {
                const loadedGames = JSON.parse(loadedGamesJSON);
                setCurrentGame(loadedGames)
                // current game il est vide a ce moment la
                if (loadedGames.selected) {
                    loadGame(loadedGames.selected, loadedGames)
                } else {
                    setReadyToDisplay(true)
                }
            } else {
                const defaultValue = {
                    selected: false,
                    available: []
                }
                setCurrentGame(defaultValue)
                localStorage.setItem(gamesStorageKey, JSON.stringify(defaultValue));
                setReadyToDisplay(true)
            }
        }

        // Vh calculation
        const handleResize = () => {
            const newVh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) * 0.01
            setCardSize({
                vh: newVh
            })
        };
        handleResize()

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    useEffect(() => {
        if (currentGame) {
            localStorage.setItem(gamesStorageKey, JSON.stringify(currentGame));
        }
    }, [currentGame])

    function switchGame(gameTitle) {
        let tmp = { ...currentGame }
        tmp.selected = gameTitle
        setCurrentGame(tmp)
        loadGame(gameTitle)
    }

    async function loadPreconsFromUrl(url) {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Network response was not ok");

            const data = await response.json();

            if (Array.isArray(data)) {
                let newDecks = []
                data.forEach(d => {
                    let deck = {...d}
                    d.deckList.categoriesOrder.forEach(cat => {
                        d.deckList[cat].forEach((card, i) => {
                            if (OLD_MTG_IDs[card.id] !== undefined) {
                                console.log("Switch from " + deck.deckList[cat][i].id + " to " + OLD_MTG_IDs[card.id])
                                deck.deckList[cat][i].id = OLD_MTG_IDs[card.id]
                            }
                        })
                    })
                    newDecks.push(deck)
                })
                console.log(newDecks)
            } else {
                console.warn("Expected an array but got:", data);
            }
        } catch (error) {
            console.error("Error loading JSON:", error);
        }
    }

    async function loadGame(gameTitle, customCurrentGame) {
        if (false) {
            setGameData(testGameData)
            setGameCards(testCardList)
            setIsLoadingGameData(false)
            setReadyToDisplay(true)
            return
        }
        let cGame = customCurrentGame ? customCurrentGame : currentGame
        setIsLoadingGameData(true)
        const availableGameIndex = cGame.available.findIndex(a => a.name === gameTitle)
        if (availableGameIndex !== -1) {
            let gameDataUrl = cGame.available[availableGameIndex].url

            // Load game data json
            let gameFileData = await fetchJSON(gameDataUrl)
            // Load game card json
            let cardsFileData = await fetchJSON(gameFileData.cards.dataUrl)

            setGameData(gameFileData)
            setGameCards(cardsFileData)
            setIsLoadingGameData(false)
            setReadyToDisplay(true)

            if (gameTitle === "Magic the Gathering") {
                const userDecksStorageKey = "user_decks_Magic the Gathering"
                let decksSavedData = localStorage.getItem(userDecksStorageKey);

                // Starter decks fix
                /*if (gameFileData.defaultRessources.decksUrl && gameFileData.defaultRessources.decksUrl.length > 0) {
                    console.log('loading starters')
                    loadPreconsFromUrl(gameFileData.defaultRessources.decksUrl)
                }*/


                // User decks fix
                if (decksSavedData) {
                    const decksSaved = JSON.parse(decksSavedData);
                    decksSaved.forEach((d) => {
                        const newDeckData = localStorage.getItem(userDecksStorageKey + '_' + d);
                        if (newDeckData) {
                            let newDeck = JSON.parse(newDeckData);
                            newDeck.deckList.categoriesOrder.forEach(cat => {
                                newDeck.deckList[cat].forEach((card, i) => {
                                    if (OLD_MTG_IDs[card.id] !== undefined) {
                                        console.log("Switch from " + newDeck.deckList[cat][i].id + " to " + OLD_MTG_IDs[card.id])
                                        newDeck.deckList[cat][i].id = OLD_MTG_IDs[card.id]
                                    }
                                })
                            })
                            console.log(newDeck)
                            localStorage.setItem(userDecksStorageKey + '_' + d, JSON.stringify(newDeck));
                        } else {
                            console.log("Error loading deck " + d)
                        }
                    })
                }
            }
        } else {
            setIsLoadingGameData(false)
            setReadyToDisplay(true)
        }
    }

    async function fetchJSON(url) {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Erreur de téléchargement pour ${url}`);
        }

        const data = await response.json();

        return data
    }

    const contextValue = useMemo(() => ({
        currentGame,
        setCurrentGame,
        switchGame,
        gameData,
        gameCards,
        isLoadingGameData,
        cardSize,
    }), [
        currentGame,
        gameData,
        gameCards,
        isLoadingGameData,
        cardSize,
    ]);

    return (
        <GameContext.Provider value={contextValue}>
            {readyToDisplay && (<div>{children}</div>)}
        </GameContext.Provider>
    );
};
